export default {"src":"/_next/static/media/vercel.ded80d76.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};